import React from "react";
import { useTable, useResizeColumns } from "react-table";
import { Row, Col, Table, Spinner, Accordion, Card, Button } from "react-bootstrap";
import Paging from "../_Components/Paging";
import { useFormContext } from "react-hook-form";
import { Avatar } from "@mui/material";
import _ from "lodash";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import { Tooltip } from "@mui/material";

const DataTable = ({ columns, data, config, redRows, yellowRows }) => {
  const { getTableProps, getTableBodyProps, headerGroups, footerGroups, prepareRow, rows } = useTable(
    {
      columns,
      data: data?.data ?? [],
      initialState: { pageIndex: 0 },
    },
    useResizeColumns,
  );
  const [activeKey, setActiveKey] = useState(null); // State for controlling the accordion

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key); // Toggle the accordion
  };

  const methods = useFormContext();
  const useStyles = styled({
    pinkAvatar: {
      marginTop: 10,
      marginRight: 2,
      marginBottom: 10,
      color: "#fff",
      width: "22px",
      height: "22px",
      alignItems: "end",
      justifyContent: "center",
    },
  });

  const classes = useStyles({});

  const changData = (rowData, isCanceledStatus = false) => {
    if (isCanceledStatus) {
      let cancelStatusesArray = [
        { cancelStatus: 1, status: "درخواست_کنسلی", bgColor: "#f64e60", color: "", bdColor: "", count: 0 },
        {
          cancelStatus: 2,
          status: "پیگیری کنسلی",
          bgColor: "#eee5ff",
          color: "#fff",
          bdColor: "transparent",
          count: 0,
        },
        { cancelStatus: 3, status: "رهاسازی کنسلی", bgColor: "#f64e60", color: "", bdColor: "transparent", count: 0 },
        { cancelStatus: 4, status: "کنسل شد", bgColor: "#99260766", color: "", bdColor: "transparent", count: 0 },
        {
          cancelStatus: 5,
          status: "رد درخواست کنسلی",
          bgColor: "#d5950e66",
          color: "",
          bdColor: "transparent",
          count: 0,
        },
      ];

      cancelStatusesArray.map((state) => {
        let count = 0;
        count += _.filter(rowData.basketItemPersons, function (basketItemPersons) {
          return basketItemPersons.cancelStatus == state.cancelStatus && basketItemPersons.cancelStatus != 0;
        }).length;
        state.count = count;
      });

      return (
        <>
          {" "}
          {cancelStatusesArray.map(
            (item, idx) =>
              item.count != 0 && (
                <Avatar
                  sx={{ width: 18, height: 18 }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-custom-class="tooltip-dark"
                  title={item.status}
                  data-bs-delay-hide="1000"
                  className={classes.pinkAvatar}
                  style={{
                    color: item.color != "" && item.color,
                    backgroundColor: item.bgColor,
                    borderColor: item.bdColor != "" && item.bdColor,
                  }}
                  key={idx}
                >
                  {item.count}{" "}
                </Avatar>
              ),
          )}
        </>
      );
    } else {
      let statusesArray = [
        { status: "جدید", bgColor: "#3699ff", count: 0 },
        { status: "در_حال_پیگیری", bgColor: "rgb(182 206 232)", count: 0 },
        { status: "رهاسازی", bgColor: "#3699ff", count: 0 },
        { status: "انجام_شده", bgColor: "#40900378", count: 0 },
        { status: "انجام_نشده", bgColor: "#d55e0185", count: 0 },
      ];
      statusesArray.map((state) => {
        let count = 0;

        count += _.filter(rowData.basketItemPersons, function (basketItemPersons) {
          return basketItemPersons.currentStatusS == state.status && basketItemPersons.cancelStatus != 4;
        }).length;

        state.count = count;
      });
      return (
        <>
          {" "}
          {statusesArray.map(
            (item, idx) =>
              item.count != 0 && (
                <Avatar
                  sx={{ width: 18, height: 18 }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-custom-class="tooltip-dark"
                  title={item.status}
                  data-bs-delay-hide="1000"
                  className={classes.pinkAvatar}
                  style={{ backgroundColor: item.bgColor, fontSize: "11px", color: "white" }}
                  key={idx}
                >
                  {item.count}{" "}
                </Avatar>
              ),
          )}
        </>
      );
    }
  };

  const showBasketDetail = (prp) => {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item, index) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += " , " + item.text;
      });
    return resDetails != "" ? resDetails : "";
  };
  return (
    <>
      <Row style={methods.formState.isSubmitting ? { opacity: "0.5" } : { opacity: "1" }}>
        <Col xs="12">
          {methods.formState.isSubmitting && (
            <div style={{ position: "absolute", top: "15rem", width: "100%", textAlign: "center", zIndex: "1000" }}>
              <Spinner animation="border" variant="primary" size={400} />
            </div>
          )}
          <div className="bg-white">
            <Table {...getTableProps()} responsive>
              <thead className="border-bottom">
                {headerGroups.map((headerGroup, idx) => (
                  <tr role="row" key={idx}>
                    <td className="p-0" colSpan={11}>
                      <div style={{ paddingRight: "35px" }}>
                        <Table responsive className="mt-1 border-bottom table-acc">
                          <tbody>
                            <tr>
                              {headerGroup.headers.map((column, idxx) => (
                                <td
                                  className="text-center"
                                  style={{
                                    textAlign: column.align,
                                    minWidth: "100px",
                                    maxWidth: "100px",
                                  }}
                                  colSpan={1}
                                  role="columnheader"
                                  key={idxx}
                                >
                                  {column.render("Header")}
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </td>
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  const basket = row.original; // دریافت داده مربوط به سطر جاری

                  return (
                    <Tooltip
                      key={i}
                      arrow
                      followCursor
                      placement="top"
                      title={
                        redRows && redRows[i] ?
                          <div style={{ fontSize: 12 }}>{row.original?.redTooltip}</div>
                          : yellowRows && yellowRows[i] ? <div style={{ fontSize: 12 }}>{row.original?.yellowTooltip}</div> : undefined}
                    >
                      <tr >
                        <td className="p-0" colSpan={11} >
                          <Accordion style={{ backgroundColor: redRows && redRows[i] ? "#fceded" : yellowRows && yellowRows[i] ? "rgba(255, 168, 0, 0.1)" : "" }} onSelect={handleToggle} activeKey={activeKey} className="table-acc border-0">
                            <Card>
                              <Card.Header style={{ backgroundColor: redRows && redRows[i] ? "#fceded" : yellowRows && yellowRows[i] ? "rgba(255, 168, 0, 0.1)" : "white" }} className="d-flex">
                                <Button
                                  variant="link"
                                  onClick={() => handleToggle(row.original.id)}
                                  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                >
                                  <span>{activeKey === row.original.id ? <ExpandLess /> : <ExpandMore />}</span>
                                </Button>
                                <Table {...getTableProps()} responsive className="mt-1  table-acc">
                                  <tbody>
                                    <tr className="border-0">
                                      {row.cells.map((cell, idx) => {
                                        return (
                                          <td
                                            className="border-0"
                                            key={idx}
                                            role="cell"
                                            style={{
                                              textAlign: "center", minWidth: "100px", maxWidth: "100px",
                                              backgroundColor: redRows && redRows[i] ? "#fceded" : yellowRows && yellowRows[i] ? "rgba(255, 168, 0, 0.1)" : ""
                                            }}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </tbody>
                                </Table>
                              </Card.Header>
                              <Accordion.Collapse eventKey={row.original.id}>
                                <Card.Body
                                  className="bg-gray  mb-2 py-0 mt-2 rounded-3 highlight-row"
                                  style={{ paddingRight: "35px", paddingLeft: "0px" }}
                                >
                                  <Table>
                                    <tbody >
                                      {basket?.basketItems?.map((basketItem, idxxx) => (
                                        <tr key={basketItem.id + `${idxxx}`}>
                                          <td
                                            style={{ textAlign: "center", minWidth: "150px", maxWidth: "200px", backgroundColor: "transparent" }}
                                          >
                                            {basketItem.amusementServiceName}
                                          </td>
                                          <td
                                            colSpan={2}
                                            style={{ textAlign: "center", minWidth: "200px", maxWidth: "300px", backgroundColor: "transparent" }}
                                          >
                                            {showBasketDetail(basketItem.details)}
                                          </td>
                                          <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                            {basketItem.checkInDate}
                                          </td>
                                          <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                            {basketItem.basketItemPersons.length} نفر{" "}
                                          </td>
                                          <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                            <div className="d-flex justify-content-center bg-transparent">
                                              {changData(basketItem)}
                                            </div>
                                          </td>
                                          <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                            <div className="d-flex justify-content-start bg-transparent">
                                              {changData(basketItem, true)}
                                            </div>
                                          </td>
                                          <td
                                            colSpan={2}
                                            style={{ textAlign: "center", minWidth: "200px", maxWidth: "200px", backgroundColor: "transparent" }}
                                          ></td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          </Accordion>
                        </td>
                      </tr>
                    </Tooltip>
                  );
                })}
              </tbody>
              {config.show_footer &&
                <tfoot style={{ background: "linear-gradient(#dfe0eb,#bbbcc6)" }}>
                  {headerGroups.map((group, idx) => (
                    <tr {...group.getFooterGroupProps()} key={idx}>
                      <td className="p-0" colSpan={11}>
                        <div style={{ paddingRight: "35px" }}>
                          <Table responsive className="table-acc">
                            <tbody>
                              <tr>
                                {group.headers.map((column, idxx) => (
                                  <td
                                    className="text-center"
                                    style={{
                                      textAlign: column.align,
                                      minWidth: "100px",
                                      maxWidth: "100px",
                                      fontWeight: "bold"
                                    }}
                                    colSpan={1}
                                    role="columnheader"
                                    key={idxx}
                                  >{column.render('Footer')}</td>
                                ))}
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tfoot>}
            </Table>
            <Paging config={config} {...methods} />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default DataTable;
